/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Homepage actions
 */

import type { DetailLink } from '@zcode/bizos'
import type { Listable, Listables } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  RECEIVE_ADDRESS_LINKS,
  RECEIVE_BUILDING_LINKS,
  RECEIVE_LISTABLES,
  RECEIVE_LUXURY_LISTABLES,
  RECEIVE_NEW_LISTABLES,
  RECEIVE_PET_LISTABLES,
  RECEIVE_SPOTLIGHT_LISTABLES,
  RECEIVE_UTILITIES_INCLUDED_LISTABLES,
  SET_IS_LISTABLES_LOADING,
  SET_IS_SPOTLIGHT_LISTABLES_LOADING,
} from '../constants/index'

export const receiveListables = createAction<Listables, typeof RECEIVE_LISTABLES>(RECEIVE_LISTABLES)
export const receiveNewListables = createAction<Listables, typeof RECEIVE_NEW_LISTABLES>(
  RECEIVE_NEW_LISTABLES
)
export const receivePetListables = createAction<Listables, typeof RECEIVE_PET_LISTABLES>(
  RECEIVE_PET_LISTABLES
)
export const receiveLuxuryListables = createAction<Listables, typeof RECEIVE_LUXURY_LISTABLES>(
  RECEIVE_LUXURY_LISTABLES
)
export const receiveUtilitiesIncludedListables = createAction<
  Listables,
  typeof RECEIVE_UTILITIES_INCLUDED_LISTABLES
>(RECEIVE_UTILITIES_INCLUDED_LISTABLES)

export const receiveSpotlightListables = createAction<
  Listable[],
  typeof RECEIVE_SPOTLIGHT_LISTABLES
>(RECEIVE_SPOTLIGHT_LISTABLES)

export const setIsListablesLoading = createAction<boolean, typeof SET_IS_LISTABLES_LOADING>(
  SET_IS_LISTABLES_LOADING
)
export const setIsSpotlightListablesLoading = createAction<
  boolean,
  typeof SET_IS_SPOTLIGHT_LISTABLES_LOADING
>(SET_IS_SPOTLIGHT_LISTABLES_LOADING)

export const receiveAddressLinks = createAction<
  readonly DetailLink[],
  typeof RECEIVE_ADDRESS_LINKS
>(RECEIVE_ADDRESS_LINKS)
export const receiveBuildingLinks = createAction<
  readonly DetailLink[],
  typeof RECEIVE_BUILDING_LINKS
>(RECEIVE_BUILDING_LINKS)
